import { ref } from 'vue';

const getTrainings = () => {
    const trainings_error = ref(null);
    const trainings = ref(null);

    const loadTrainings = async () => {
      try {
        let data = await fetch("/api/trainings/actual");

        if (!data.ok) {
          throw Error("Can't load data");
        }

        trainings.value = await data.json();

       //console.log('trainings', trainings.value);
      } catch (err) {
        trainings_error.value = err.message;
      }
    };

    return { trainings, trainings_error, loadTrainings};
}

export default getTrainings;